// The label the ownership record is published under.
//
// In `common` rather than beside the verifier that reads it, because the screen
// that tells somebody what to publish and the code that checks it must agree
// exactly — a prefix that drifts between them fails verification for a record
// the person was told to create, with nothing on either side to say why.
//
// gen-1 used `pws-domain-owner` (pagews-api-gateway/src/models/account-domain).
// Renamed because this generation is not that product; the VALUE is a per-row
// token rather than gen-1's account id, because an account id is shared across
// every domain an organization owns, so one published record would prove
// ownership of all of them.
export const TXT_PREFIX = "pagews-site-verification";
